import React from 'react';
import PropTypes from 'prop-types';

import {Box, SkeletonText} from '@spothero/ui';

import Card from 'common/card/Card';

const outlineStyles = {
    outline: '1px solid',
    outlineColor: 'gray.200',
    outlineOffset: '-1px',
};

const skeletonCardHeadingStyles = {
    ...outlineStyles,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    height: 14,
    padding: 4,
};

const skeletonCardDetailsStyles = {
    ...outlineStyles,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    height: 28,
    paddingX: 4,
    paddingY: 6,
    marginTop: '-1px',
};

const SkeletonCard = ({index, style}) => {
    return (
        <Card
            data-testid="SkeletonCard"
            key={index}
            {...style}
            width="fill-available"
            paddingX={0}
            paddingY={2}
            marginX={2}
        >
            <Box {...skeletonCardHeadingStyles}>
                <SkeletonText noOfLines={1} spacing="2" skeletonHeight="4" />
            </Box>
            <Box {...skeletonCardDetailsStyles}>
                <SkeletonText noOfLines={3} spacing="2" skeletonHeight="4" />
            </Box>
        </Card>
    );
};

SkeletonCard.propTypes = {
    index: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
};

export default SkeletonCard;
